import { render, staticRenderFns } from "./ProductoFormulario.vue?vue&type=template&id=58889c67"
import script from "./ProductoFormulario.vue?vue&type=script&lang=js"
export * from "./ProductoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports